import {ColonistCoinProduct} from '../../../../shared/store/ColonistCoinProduct'
import {createDivIn, createImgIn, createHeaderIn, createLinkIn, createParagraphIn, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {doActionIfLoggedIn} from '../../../shared/scripts/store/StoreUtils'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {UIAPIEndpoints} from '../../../shared/scripts/network/UIAPIEndpoints'
import {TranslationObject} from '@colonist/i18n'
import {navigateToPage} from '../ui_utils/ClientUtils.ts'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'
import {AudioManager, AudioType} from '@colonist/audio'
import {LocalizedPriceData} from '@colonist/mobile'

export class UICoinProductView {
    protected readonly product: ColonistCoinProduct
    private readonly productUrl: string

    constructor(container: HTMLDivElement, product: ColonistCoinProduct, onClickEvent?: () => void, localizedPriceData?: LocalizedPriceData) {
        this.product = product

        const productDiv = createDivIn(container, 'store_page_coin_product', '')

        const bodyDiv = createDivIn(productDiv, 'store_page_coin_product_body', '')
        const img = createImgIn(bodyDiv, product.lobbyImage)

        const headerDiv = createDivIn(productDiv, 'store_page_coin_product_header')
        const coinsTotalText: TranslationObject = {key: 'strings:storePage.coins.title', options: {count: product.baseCoinAmount + product.bonusCoinAmount}}
        const coinsTotal = createHeaderIn(headerDiv, coinsTotalText, '', '', 'H2')

        if(product.bonusCoinAmount != 0) {
            const coinAmount = createParagraphIn(headerDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: product.baseCoinAmount + ' '}}, '')
            const bonusAmount = createParagraphIn(coinAmount, {key: 'strings:storePage.coins.bonusAmount', options: {count: product.bonusCoinAmount}}, 'store_page_coin_product_bonus')
        }

        this.productUrl = UIAPIEndpoints.checkoutProductUrl(product.type)
        const priceValue = localizedPriceData ? `${localizedPriceData.currency}${localizedPriceData.price}` : product.getUSDPriceWithSign()
        const priceText: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: priceValue}}
        const buyButton = createLinkIn(productDiv, '#', priceText, 'store_button btn_general')
        setElementOnClick(buyButton, () => this.handleBuyButtonClicked(onClickEvent))

        if(product.bannerText != undefined) {
            const isMobile = UIUtilsEjsVariables.isUserOnMobileAppOrWeb
            const bannerDiv = createDivIn(productDiv, isMobile ? 'badge-orange badge-md' : 'badge-orange badge-lg')
            const banner = createParagraphIn(bannerDiv, product.bannerText, '')
        }
    }

    protected handleBuyButtonClicked(onClickEvent?: () => void) {
        AudioManager.play(AudioType.Click)
        CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedPurchaseCoin, this.product.price)

        if(onClickEvent) onClickEvent()

        doActionIfLoggedIn(() => {
            if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return
            navigateToPage(this.productUrl)
        })
    }
}
